/**
 * Created by claudenbach on 1/25/2017.
 */

import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmPercentSerializer = (
  lmFormatUtilService: LMFormatUtilService,
  value: string,
  oldValue: string,
  columnDef: ListGridColumn,
  row: number,
  cell: number,
  dataView: LMListDataView
): string => lmFormatUtilService.percentToData(value, {decSize: columnDef.displayField.decSize});
